import React from 'react';
import { motion } from 'framer-motion';
import { Phone, EnvelopeSimple, MapPin, InstagramLogo } from '@phosphor-icons/react';
import { CONTACT_INFO } from '../App';

const Contact = () => {
  return (
    <div className="bg-black min-h-screen">
      {/* Hero */}
      <section className="pt-32 pb-20 px-6 lg:px-12">
        <div className="max-w-4xl mx-auto text-center">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8 }}
          >
            <h1 className="font-display text-4xl sm:text-5xl lg:text-6xl tracking-tight text-white mb-4">
              Contact
            </h1>
            <div className="w-16 h-px bg-white/30 mx-auto mt-6"></div>
            <p className="text-lg text-white/60 mt-6 max-w-xl mx-auto">
              Retrouvez toutes nos coordonnées pour nous joindre directement
            </p>
          </motion.div>
        </div>
      </section>

      {/* Contact Information - Large Cards */}
      <section className="pb-32 px-6 lg:px-12">
        <div className="max-w-5xl mx-auto">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
            {/* Téléphone */}
            <motion.a
              href={`tel:${CONTACT_INFO.phone.replace(/\s/g, '')}`}
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6, delay: 0.1 }}
              className="group p-12 border border-white/10 hover:border-white/30 transition-all duration-300 text-center"
            >
              <div className="w-20 h-20 mx-auto mb-6 rounded-full border border-white/20 flex items-center justify-center group-hover:border-white/50 transition-colors">
                <Phone size={36} weight="thin" className="text-white" />
              </div>
              <h2 className="font-display text-2xl text-white mb-3">Téléphone</h2>
              <p className="text-2xl lg:text-3xl text-white/80 font-light tracking-wide group-hover:text-white transition-colors">
                {CONTACT_INFO.phone}
              </p>
              <p className="text-white/40 text-sm mt-4">
                Du lundi au vendredi, 9h - 18h
              </p>
            </motion.a>

            {/* Email */}
            <motion.a
              href={`mailto:${CONTACT_INFO.email}`}
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6, delay: 0.2 }}
              className="group p-12 border border-white/10 hover:border-white/30 transition-all duration-300 text-center"
            >
              <div className="w-20 h-20 mx-auto mb-6 rounded-full border border-white/20 flex items-center justify-center group-hover:border-white/50 transition-colors">
                <EnvelopeSimple size={36} weight="thin" className="text-white" />
              </div>
              <h2 className="font-display text-2xl text-white mb-3">Email</h2>
              <p className="text-xl lg:text-2xl text-white/80 font-light group-hover:text-white transition-colors break-all">
                {CONTACT_INFO.email}
              </p>
              <p className="text-white/40 text-sm mt-4">
                Réponse sous 24-48h
              </p>
            </motion.a>

            {/* Adresse */}
            <motion.div
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6, delay: 0.3 }}
              className="group p-12 border border-white/10 text-center"
            >
              <div className="w-20 h-20 mx-auto mb-6 rounded-full border border-white/20 flex items-center justify-center">
                <MapPin size={36} weight="thin" className="text-white" />
              </div>
              <h2 className="font-display text-2xl text-white mb-3">Adresse</h2>
              <p className="text-xl lg:text-2xl text-white/80 font-light">
                {CONTACT_INFO.address}
              </p>
              <p className="text-xl lg:text-2xl text-white/80 font-light">
                {CONTACT_INFO.city}
              </p>
            </motion.div>

            {/* Instagram */}
            <motion.a
              href="https://www.instagram.com/studiobar.paris/"
              target="_blank"
              rel="noopener noreferrer"
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6, delay: 0.4 }}
              className="group p-12 border border-white/10 hover:border-white/30 transition-all duration-300 text-center"
            >
              <div className="w-20 h-20 mx-auto mb-6 rounded-full border border-white/20 flex items-center justify-center group-hover:border-white/50 transition-colors">
                <InstagramLogo size={36} weight="thin" className="text-white" />
              </div>
              <h2 className="font-display text-2xl text-white mb-3">Instagram</h2>
              <p className="text-xl lg:text-2xl text-white/80 font-light group-hover:text-white transition-colors">
                @studiobar.paris
              </p>
              <p className="text-white/40 text-sm mt-4">
                Suivez nos créations
              </p>
            </motion.a>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Contact;
